export default __webpack_public_path__ + "static/media/poster-4-GlycoTree.da94208b.png";